import {Col, DatePicker, Form, Input, Row, Select} from 'antd';
import React from 'react';
import EditFormComponent from '../common/EditFormComponent';
import {Arguments} from '../common/Arguments';
import SaveButtonComponent from '../common/SaveButtonComponent';
import AddFormComponent from '../common/AddFormComponent';
import {validateWhiteSpace} from '../common/ValidateWhiteSpace';

const layout = {
	labelCol: {span: 10},
	wrapperCol: {span: 14},
};

const tailLayout = {
	wrapperCol: {offset: 5, span: 16},
};

const AddBranchMembers = () => {
	const currentUrl = window.location.href;

	const apiList = [
		Arguments.host + '/society_organization/base/branch/api!addBranchPartyBranchMember.do',
		Arguments.host + '/society_organization/society/api!addMemberPersonal.do',
	];

	return (currentUrl.endsWith('add') ?
			<AddFormComponent UserForm={BranchMembersForm} url={apiList}/> :
			<EditFormComponent UserForm={BranchMembersForm} url={apiList}/>
	);
};
const BranchMembersForm = ({onFinish, initialValues}) => {
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			initialValues={initialValues}
			style={{maxWidth: 800, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={12}>
					<Form.Item name="memberName" label="姓名"
							   rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input disabled={window.location.href.endsWith('edit')}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="memberBorn" label="出生日期"
							   rules={[{required: true, message: '内容不能为空'}]}>
						<DatePicker placeholder="选择日期" disabled={window.location.href.endsWith('edit')}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 5}}
						wrapperCol={{span: 19}}
						name="memberUnit" label="工作单位（或原）"
						rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input disabled={window.location.href.endsWith('edit')}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="memberDate" label="入党日期">
						<DatePicker placeholder="选择日期"/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="partyPost" label="党内职务">
						<Select>
							<Select.Option value="书记">书记</Select.Option>
							<Select.Option value="副书记">副书记</Select.Option>
							<Select.Option value="组织委员">组织委员</Select.Option>
							<Select.Option value="宣传委员 ">宣传委员</Select.Option>
							<Select.Option value="纪检委员 ">纪检委员</Select.Option>
							<Select.Option value="其他">其他</Select.Option>
						</Select>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="organizationPost" label="学会内职务">
						<Select>
							<Select.Option value="会长（理事长）">会长（理事长）</Select.Option>
							<Select.Option value="副会长（副理事长）">副会长（副理事长）</Select.Option>
							<Select.Option value="副会长（兼秘书长）">副会长（兼秘书长）</Select.Option>
							<Select.Option value="秘书长">秘书长</Select.Option>
							<Select.Option value="副秘书长">副秘书长</Select.Option>
							<Select.Option value="常务理事">常务理事</Select.Option>
							<Select.Option value="理事">理事</Select.Option>
							<Select.Option value="监事长">监事长</Select.Option>
							<Select.Option value="监事">监事</Select.Option>
							<Select.Option value="普通会员">普通会员</Select.Option>
						</Select>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 5}}
						wrapperCol={{span: 19}}
						name="memberZzgxUnit" label="组织关系所在单位">
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<SaveButtonComponent/>
			</Form.Item>
		</Form>
	);
};

export default AddBranchMembers;
